import { getTipos, createTipo, updateTipo, deleteTipo } from '../models/tipoModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from 'svelte-toasts';

export async function fetchTipos(page, perPage) {
  try {
    const response = await getTipos(page, perPage);
    return {
      tipo: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    // Handle auto-cancellation errors gracefully
    if (error.message && error.message.includes('autocancelled')) {
      console.warn('Fetch request was auto-cancelled, this is normal for rapid updates');
      return {
        tipo: [],
        totalRecords: 0,
        currentPage: page,
      };
    }
    console.error("Error fetching tipos:", error);
    Swal.fire('Error', 'No se pudieron cargar los tipos', 'error');
    return null;
  }
}

export async function saveTipo(tipo, currentTipoId) {
  try {
    if (currentTipoId) {
      await updateTipo(currentTipoId, tipo);
      toasts.add({
        title: 'Éxito',
        description: 'Tipo guardado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    } else {
      await createTipo(tipo);
      toasts.add({
        title: 'Éxito',
        description: 'Tipo creado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    }
  } catch (error) {
    console.error("Error saving tipo:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el tipo',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  }
}

export async function removeTipo(id) {
  try {
    await deleteTipo(id);
    toasts.add({
      title: 'Éxito',
      description: 'Tipo eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  } catch (error) {
    console.error("Error deleting tipo:", error);
    Swal.fire('Error', 'No se pudo eliminar el tipo', 'error');
  }
}

// Variable global para el timeout de actualización
let tipoUpdateTimeout;

// Suscripción en tiempo real a cambios en la colección 'tipo'
export function subscribeToTipos(searchQuery, handleSearch) {
  pb.collection('tipo').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    
    // Clear any pending update
    if (tipoUpdateTimeout) {
      clearTimeout(tipoUpdateTimeout);
    }
    
    // Debounce the update to prevent rapid successive calls
    tipoUpdateTimeout = setTimeout(async () => {
      try {
        await handleSearch(); // Actualiza la lista manteniendo la página actual
      } catch (error) {
        console.warn('Error en actualización en tiempo real:', error);
        // Don't show error to user for real-time updates
      }
    }, 300); // Wait 300ms before updating
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromTipos() {
  // Clear any pending update timeout
  if (tipoUpdateTimeout) {
    clearTimeout(tipoUpdateTimeout);
    tipoUpdateTimeout = null;
  }
  pb.collection('tipo').unsubscribe('*');
}

export async function searchTipos(query, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('tipo').getList(page, perPage, {
      filter: `descrip ~ "${query}"`,
      $autoCancel: false // Disable auto-cancellation for search requests
    });
    return {
      tipo: response.items,
      totalRecords: response.totalItems,
      currentPage: response.currentPage,
    };
  } catch (error) {
    // Handle auto-cancellation errors gracefully
    if (error.message && error.message.includes('autocancelled')) {
      console.warn('Search request was auto-cancelled, this is normal for rapid updates');
      return {
        tipo: [],
        totalRecords: 0,
        currentPage: page,
      };
    }
    console.error("Error searching tipos:", error);
    throw error;
  }
}
